(function () {
  const drawerToggle = document.getElementById('Details-menu-drawer-container');
  if (!drawerToggle) return;
  const headerDrawerHost = document.querySelector('header-drawer');

  function isVisibleFocusable(el) {
    if (el.closest('[inert]')) return false;
    if (typeof el.checkVisibility === 'function') {
      return el.checkVisibility({ checkOpacity: false, checkVisibilityCSS: true });
    }
    const style = getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return el.getClientRects().length > 0;
  }

  function getVisibleFocusableElements(container) {
    return getFocusableElements(container).filter(isVisibleFocusable);
  }

  function setBackgroundInert(makeInert) {
    Array.from(document.body.children).forEach((el) => {
      if (!el.contains(headerDrawerHost)) el.inert = makeInert;
    });
  }

  function onDrawerKeydown(event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (document.activeElement.closest('.header__search')) return;

    const elements = getVisibleFocusableElements(drawerToggle);
    if (!elements.length) return;
    const first = elements[0];
    const last = elements[elements.length - 1];

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    } else if (event.target === first && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  }

  function syncDrawerState() {
    const isOpen = drawerToggle.classList.contains('menu-opening');
    setBackgroundInert(isOpen);
    if (isOpen) document.addEventListener('keydown', onDrawerKeydown);
    else document.removeEventListener('keydown', onDrawerKeydown);
  }

  const observer = new MutationObserver(syncDrawerState);
  observer.observe(drawerToggle, { attributes: true, attributeFilter: ['class'] });

  syncDrawerState();
})();
